module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYEAAAAGCAYAAAAlmyLwAAAAAXNSR0IArs4c6QAAAJdJREFUaEPt2aEKgDAURuF/wSw2Qdb1JQ17Pvu6MxvEaBC7YWHhXjjLYxy+hQtbiOuySRrlbAXp3lOenWWTiwACCJgSCHFdTkmDqaq6mKek3NVtZRcCCCCAwJ/ANwQOSZNDnquk3DvsJhkBBBAwI+B5CJhBJAQBBBBwKnDzHOT05shGAAEEWgh8Q4CP4RaSnIEAAgg4FHgBiv8bvta/8BIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy/sy_xhx.png
// module id = s93z
// module chunks = 1